import React from 'react';
import { InputTextArea } from '@spark';
import SettingsSectionCard from './SettingsSectionCard.jsx';
import { handleCopy } from '@/shared/utils/helpers';
import './settings.css';

/** Streamable-HTTP endpoint of this install's MCP server (``backend/app/mcp``). */
export const mcpServerUrl = () => `${window.location.origin}/api/mcp`;

/**
 * Client configuration that points an MCP client at this platform — the
 * ``mcpServers`` shape Cursor, VS Code and Claude Code all read. The Figma
 * (9851:18381) names the server ``Specific.ai``. Two-space indentation keeps
 * the ``url`` line unwrapped inside the 427px snippet box.
 */
export const mcpConfigSnippet = (url) => JSON.stringify({ mcpServers: { 'Specific.ai': { url } } }, null, 2);

/**
 * Settings → MCP (Figma 9851:18381): the "Specific’s MCP" section with a
 * read-only, copyable code snippet under "Connect with any workspace".
 * Rendered only when the backend reports ``mcp_enabled`` (see ``Settings``).
 */
const McpSettings = () => (
    <SettingsSectionCard iconSlug="mcp" title="Specific’s MCP">
        <div className="settings-mcp">
            <h3 className="settings-subheading fs-unmask">Connect with any workspace</h3>
            <InputTextArea
                code
                readOnly
                label="Code Snippet"
                value={mcpConfigSnippet(mcpServerUrl())}
                className="settings-mcp__snippet fs-unmask"
                onCopy={handleCopy}
            />
        </div>
    </SettingsSectionCard>
);

export default McpSettings;
